import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSEO({ title, description, type = "website", path = "", image, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", window.location.origin + path);
    upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", window.location.origin + path);

    document.querySelectorAll("script[data-seo-jsonld]").forEach((n) => n.remove());
    (jsonLd || []).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "true");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    });
    return () => {
      document.querySelectorAll("script[data-seo-jsonld]").forEach((n) => n.remove());
    };
  }, [title, description, type, path, image, JSON.stringify(jsonLd || [])]);
}

export { organizationSchema, faqSchema } from "./schema";

export function articleSchema(post) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: post?.title,
    description: post?.excerpt || post?.seo_description,
    image: post?.cover_image || undefined,
    author: { "@type": "Organization", name: post?.author || "RenB Editorial" },
    datePublished: post?.published_at,
  };
}

export function serviceSchema(series) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: series?.title,
    description: series?.excerpt,
    provider: { "@type": "Organization", name: "RenB Solutions" },
  };
}
